import styled from 'styled-components';
import React, {FC} from 'react';
import {Link} from 'gatsby';

import {fontWeights, mediaBreakpointDown, mediaBreakpointUp} from '../../lib/styleVariables';
import {fontSizesMixinsR4, paletteR4Secondary} from '../../lib/styleVariablesR4';
import {useTranslation} from '../../context/translation';
import {getElementVisibility} from '../../lib/windowHelpers';

const TOP_BAR_CLASS_NAME = 'TOP_BAR';

export const getTopBarHeight = async () => {
  const topBarElement: any = document.querySelector(`.${TOP_BAR_CLASS_NAME}`);
  const {isVisible, visibilityRatio} = await getElementVisibility(topBarElement);
  const topBarElementHeight = topBarElement && isVisible ? topBarElement.offsetHeight * visibilityRatio : 0;

  return topBarElementHeight;
};

interface TopBarProps {
  bgColor?: string;
  textColor?: string;
}

const StyledTopBar = styled.div<TopBarProps>`
  ${fontSizesMixinsR4.p2()};
  line-height: 26px;
  display: flex;
  justify-content: center;
  padding: 16px;

  background-color: ${props => props.bgColor};
  color: ${props => props.textColor};

  ${mediaBreakpointDown('mobile')} {
    ${fontSizesMixinsR4.p4()};
    flex-direction: column;
    align-items: flex-start;
    line-height: 150%;
  }
`;

const StyledText = styled.span``;

const StyledLink = styled(Link)`
  color: inherit;
  font-weight: ${fontWeights.bold};
  white-space: nowrap;
  ${mediaBreakpointUp('desktop')} {
    margin-left: 3px;
  }
`;

export const TopBarR4: FC = () => {
  const {t} = useTranslation();
  const display = t('top-bar.display').toLowerCase() === 'true';

  if (!display)
    return null;

  const text = t('top-bar.text');
  const buttonText = t('top-bar.button-text');
  const buttonLink = t('top-bar.button-link');
  const bgColor = t('top-bar.background-color');
  const textColor = t('top-bar.text-color');
  const hasButton = buttonText && buttonLink;

  return (
    <StyledTopBar
      className={TOP_BAR_CLASS_NAME}
      bgColor={bgColor}
      textColor={textColor}
    >
      <StyledText>{text}</StyledText>
      {hasButton && <StyledLink to={buttonLink}>{buttonText}</StyledLink>}
    </StyledTopBar>
  );
};
